// Filters and page of the orders list (/commandes), kept in sessionStorage so that
// coming back from an order's detail page restores them. Every other way of opening
// /commandes clears them (see beforeRouteEnter in ordersMenu/index.vue).
const STATE_KEY = 'ordersListState'

export function readOrdersListState() {
    try {
        return JSON.parse(sessionStorage.getItem(STATE_KEY)) || {}
    } catch (e) {
        return {}
    }
}

export function saveOrdersListState(part) {
    try {
        sessionStorage.setItem(STATE_KEY, JSON.stringify(Object.assign(readOrdersListState(), part)))
    } catch (e) {
        // storage unavailable: the list simply opens with default filters
    }
}

export function clearOrdersListState() {
    try {
        sessionStorage.removeItem(STATE_KEY)
    } catch (e) {
        // storage unavailable: nothing to clear
    }
}
